import { CheckCircle, AlertTriangle, XCircle, Wrench } from "lucide-react";

interface OverallStatusProps {
  status: string;
}

interface StatusConfig {
  label: string;
  icon: React.ComponentType<{ className?: string }>;
  bgClass: string;
  textClass: string;
  iconClass: string;
}

const STATUS_MAP: Record<string, StatusConfig> = {
  operational: {
    label: "All Systems Operational",
    icon: CheckCircle,
    bgClass: "bg-emerald-50 border-emerald-200",
    textClass: "text-emerald-800",
    iconClass: "text-emerald-500",
  },
  degraded: {
    label: "Degraded Performance",
    icon: AlertTriangle,
    bgClass: "bg-amber-50 border-amber-200",
    textClass: "text-amber-800",
    iconClass: "text-amber-500",
  },
  partial_outage: {
    label: "Partial System Outage",
    icon: AlertTriangle,
    bgClass: "bg-orange-50 border-orange-200",
    textClass: "text-orange-800",
    iconClass: "text-orange-500",
  },
  major_outage: {
    label: "Major System Outage",
    icon: XCircle,
    bgClass: "bg-red-50 border-red-200",
    textClass: "text-red-800",
    iconClass: "text-red-500",
  },
  maintenance: {
    label: "Under Maintenance",
    icon: Wrench,
    bgClass: "bg-indigo-50 border-indigo-200",
    textClass: "text-indigo-800",
    iconClass: "text-indigo-500",
  },
};

const DEFAULT_CONFIG: StatusConfig = {
  label: "Status Unknown",
  icon: AlertTriangle,
  bgClass: "bg-gray-50 border-gray-200",
  textClass: "text-gray-800",
  iconClass: "text-gray-500",
};

export default function OverallStatus({ status }: OverallStatusProps) {
  const config = STATUS_MAP[status] ?? DEFAULT_CONFIG;
  const Icon = config.icon;

  return (
    <div
      className={`w-full rounded-lg border p-4 sm:p-6 ${config.bgClass}`}
      role="status"
      aria-label={config.label}
    >
      <div className="flex items-center justify-center gap-3">
        <Icon className={`h-6 w-6 flex-shrink-0 ${config.iconClass}`} />
        <span className={`text-lg font-semibold ${config.textClass}`}>
          {config.label}
        </span>
      </div>
    </div>
  );
}
